var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrganizationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    fill: "none",
    viewBox: "0 0 24 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16.585 6.994c0 2.502-2.028 4.53-4.53 4.53-2.502 0-4.53-2.028-4.53-4.53 0-2.502 2.028-4.53 4.53-4.53 2.502 0 4.53 2.028 4.53 4.53zm-.904 5.495c1.781-1.178 2.956-3.2 2.956-5.495 0-3.635-2.947-6.582-6.582-6.582-3.636 0-6.583 2.947-6.583 6.582 0 2.296 1.175 4.317 2.957 5.495-4.01 1.302-7.006 4.702-7.553 8.832-.099.75.523 1.365 1.279 1.365h19.8c.756 0 1.378-.616 1.278-1.365-.547-4.13-3.542-7.53-7.552-8.832zm-3.626 1.483c4.403 0 7.993 2.894 8.959 6.662H3.096c.965-3.768 4.556-6.662 8.959-6.662z",
    clipRule: "evenodd",
    opacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationIcon);
export default __webpack_public_path__ + "static/media/organization-icon.0822a7dd56aa6fcf282fb6ded61dc9c7.svg";
export { ForwardRef as ReactComponent };